import { getCommitmentHistory } from "./commitmentHistory";
import {
  getDeal,
  getDeals,
  getProjectReturns,
  getReturnCalculator,
  getReturnCalculatorV2,
  getIfIsaLiveDeals,
  getIfIsaTransferDestinations,
  getDealsFundraisingCapacity,
} from "./deal";
import {
  getInvestor,
  getOnboardingV2Progress,
  getOnboardingRulesProgress,
  postNPS,
  getAccreditationQuestionnaire,
  completeOnboardingV2,
  acknowledgeRiskWarning,
  onboardInvestor,
  getDealInterestStatus,
  reaccreditateInvestor,
  submitOnboardingAccreditation,
  submitMandatoryQuestionnaire,
  submitQuickSurvey,
  getMandatoryQuestionnaire,
  postMarketingPreferences,
  postPMF,
  getWatchlist,
  addToWatchlist,
  removeFromWatchlist,
  updateOnboardingV2Profile,
  updateDealReminder,
  updateInvestor,
} from "./investor";
import {
  postCommitment,
  postPayment,
  getCommitments,
  getCommitmentPreview,
  getPaymentHistories,
  getPendingPayments,
  getCommitmentUpcomingPeriodRate,
} from "./commitment";
import { getPortfolio, getPortfolioPerformance } from "./portfolio";
import { postQuiz, getQuiz } from "./quiz";
import {
  getEntities,
  postEntityBankAccount,
  postEntity,
  uploadEntityDocument,
  deleteEntityDocument,
} from "./entity";
import {
  uploadKYCDocument,
  deleteKYCDocument,
  deleteKycDocument,
  postSourceOfFundDescription,
  putKycDescriptions,
  markKycSubmitted,
} from "./kyc";
import {
  downloadGiftAidStatementDocument,
  downloadInvestmentStatementDocument,
  downloadInvestmentStatementDocumentV2,
  downloadPerformanceOverviewDocument,
  downloadPortfolioOverviewDocument,
  generateZakatStatement,
  getDocuments,
  getPortfolioStatementAvailablePeriods,
  signDocument,
} from "./documents";
import {
  membershipCheckoutSession,
  acknowledgePayment,
  cancelPayment,
} from "./payments";
import {
  deleteUserBankAccount,
  getBankAccountDeals,
  getRecommendedBankAccount,
  getUserBankAccounts,
  patchUserBankAccount,
  postUserBankAccount,
  putUserBankAccount,
  setDefaultBankAccount,
} from "./user-bank-account";
import {
  createLiquidation,
  findLiquidationById,
  getLiquidationInfo,
} from "./liquidation";
import {
  getCommitmentActivity,
  getDistributionDetail,
  getEarningsDestinations,
  setEarningsDestination,
} from "./commitmentActivity";
import { findWithdrawalById } from "./withdrawal";
import { findPaymentById } from "./clientPayment";
import {
  cancelTransitionRequest,
  createTransitionRequest,
  findTransitionRequestById,
  getReallocationQuote,
  getTransitionQuote,
} from "./clientTransitionRequest";
import { findReallocationById } from "./clientReallocation";
import { findInvestmentById, getEISFundInvestments } from "./investment";
import { findDividendById } from "./dividend";
import {
  getCurrencyConversionRates,
  getCurrencyConversionRatesV2,
  getCurrencyConversionRatesBySourceCurrency,
} from "./currencyConversionRate";
import {
  createZakatAsset,
  createZakatLiability,
  updateZakat,
  updateZakatAsset,
  updateZakatLiability,
  deleteZakatAsset,
  deleteZakatLiability,
  getNisab,
  getZakat,
  getAllZakats,
  getZakatPortfolio,
  getZakatBreakdown,
  createZakatPayment,
  getZakatFormula,
  getZakatById,
  cloneLatestZakat,
  getDraftZakat,
  createDraftZakat,
  updateDraftZakat,
} from "./zakat";
import { queryDealBot } from "./dealBot";
import {
  createTaxResidency,
  updateTaxResidency,
  deleteTaxResidency,
} from "./taxResidency";
import {
  findInvestmentUpdates,
  markInvestmentUpdateAsViewed,
} from "./investmentUpdates";
import {
  checkPlaidCoverage,
  getBankVerificationLinkToken,
  verifyBankAccount,
  getPaymentInitiationLinkToken,
  getIdvLinkToken,
  createBankAccountFromPlaid,
} from "./plaid";
import {
  getIfIsaAccount,
  createIfIsaAccount,
  updateIfIsaAccount,
  getYearlyContributionForCurrentYear,
  createIfIsaTransfer,
  getMyIfIsaTransfers,
  uploadIfIsaTransferSignature,
} from "./ifIsa";
import {
  getGooglePlacesDetails,
  postGooglePlacesReverseGeocode,
  postGooglePlacesAutocomplete,
} from "./googlePlaces";
import { getGlossary } from "./glossary";
import { getEventById, getEvents } from "./events";
import { createDevReport } from "./devReport";
import { createInstallAttribution } from "./install-attribution";
import {
  getEarningsCalendarTimeline,
  getUpcomingEarnings,
} from "./earningsCalendar";
import {
  submitNoticePeriodChoice,
  getNoticePeriodChoices,
} from "./noticePeriodChoice";
import { getIsaWrapEligibility, submitIsaWrap } from "./isaWrap";
import {
  getActiveLossEventsForMe,
  submitLossEventBuybackResponse,
  getLossEventSpaPreview,
  getLossEventDocuments,
} from "./loss-events";

export default {
  acknowledgePayment,
  cancelPayment,
  deleteEntityDocument,
  deleteKYCDocument,
  deleteKycDocument,
  downloadInvestmentStatementDocument,
  downloadInvestmentStatementDocumentV2,
  downloadPerformanceOverviewDocument,
  downloadPortfolioOverviewDocument,
  getAccreditationQuestionnaire,
  getCommitmentHistory,
  getCommitmentPreview,
  getCommitments,
  getPendingPayments,
  getCommitmentUpcomingPeriodRate,
  getDeal,
  getDeals,
  getProjectReturns,
  getEntities,
  getInvestor,
  getOnboardingV2Progress,
  getOnboardingRulesProgress,
  getDealInterestStatus,
  getPaymentHistories,
  getPortfolio,
  getPortfolioPerformance,
  getQuiz,
  membershipCheckoutSession,
  postCommitment,
  postPayment,
  completeOnboardingV2,
  acknowledgeRiskWarning,
  onboardInvestor,
  postEntity,
  postEntityBankAccount,
  postNPS,
  postMarketingPreferences,
  updateOnboardingV2Profile,
  updateDealReminder,
  updateInvestor,
  postQuiz,
  postSourceOfFundDescription,
  putKycDescriptions,
  markKycSubmitted,
  reaccreditateInvestor,
  submitOnboardingAccreditation,
  uploadEntityDocument,
  uploadKYCDocument,
  getReturnCalculator,
  getReturnCalculatorV2,
  generateZakatStatement,
  downloadGiftAidStatementDocument,
  getDocuments,
  signDocument,
  getUserBankAccounts,
  postUserBankAccount,
  putUserBankAccount,
  patchUserBankAccount,
  deleteUserBankAccount,
  setDefaultBankAccount,
  getBankAccountDeals,
  getRecommendedBankAccount,
  findLiquidationById,
  getLiquidationInfo,
  createLiquidation,
  getCommitmentActivity,
  getDistributionDetail,
  getEarningsDestinations,
  setEarningsDestination,
  findWithdrawalById,
  findPaymentById,
  findTransitionRequestById,
  getTransitionQuote,
  getReallocationQuote,
  cancelTransitionRequest,
  createTransitionRequest,
  findReallocationById,
  getMandatoryQuestionnaire,
  submitMandatoryQuestionnaire,
  submitQuickSurvey,
  findInvestmentById,
  findDividendById,
  getCurrencyConversionRates,
  getCurrencyConversionRatesV2,
  getCurrencyConversionRatesBySourceCurrency,
  updateZakat,
  createZakatAsset,
  updateZakatAsset,
  createZakatLiability,
  updateZakatLiability,
  deleteZakatAsset,
  deleteZakatLiability,
  getNisab,
  getZakat,
  getAllZakats,
  getZakatPortfolio,
  getZakatBreakdown,
  createZakatPayment,
  getZakatFormula,
  getZakatById,
  cloneLatestZakat,
  getDraftZakat,
  createDraftZakat,
  updateDraftZakat,
  postPMF,
  queryDealBot,
  createTaxResidency,
  updateTaxResidency,
  deleteTaxResidency,
  findInvestmentUpdates,
  markInvestmentUpdateAsViewed,
  checkPlaidCoverage,
  getBankVerificationLinkToken,
  verifyBankAccount,
  getPaymentInitiationLinkToken,
  getWatchlist,
  addToWatchlist,
  removeFromWatchlist,
  getIfIsaAccount,
  createIfIsaAccount,
  updateIfIsaAccount,
  getYearlyContributionForCurrentYear,
  createIfIsaTransfer,
  uploadIfIsaTransferSignature,
  getMyIfIsaTransfers,
  getIdvLinkToken,
  getIfIsaLiveDeals,
  getIfIsaTransferDestinations,
  getDealsFundraisingCapacity,
  createBankAccountFromPlaid,
  postGooglePlacesAutocomplete,
  getGooglePlacesDetails,
  postGooglePlacesReverseGeocode,
  getGlossary,
  getEvents,
  getEventById,
  getEISFundInvestments,
  createDevReport,
  createInstallAttribution,
  getEarningsCalendarTimeline,
  getUpcomingEarnings,
  submitNoticePeriodChoice,
  getNoticePeriodChoices,
  getIsaWrapEligibility,
  submitIsaWrap,
  getPortfolioStatementAvailablePeriods,
  getActiveLossEventsForMe,
  submitLossEventBuybackResponse,
  getLossEventSpaPreview,
  getLossEventDocuments,
};
